import { Fragment, useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';

import FolderAndFile from "../BucketComponents/FolderAndFile/FolderAndFile";

import { useStore } from "../../hook-store/store";
import { 
  getObjectFile, 
  getOriginalFileNameFromKey,
} from "../../utils/bucket/bucket-object-util";
import { BACKEND_URL, loginPageLink, signupPageLink } from "../../App";

import { marks } from "../../utils/marks";
// import './ImageFusion.css';
import './ImageResizerFileSelectContents.css'

export default function ImageFusionFileSelectContents(props) {
  const { 
    setShowFileSelectModal,
    setResizerFilesFromUploadedHandler,
    isLoading,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { bucketName } = store.bucketObjectStore;
  const { isFusionServer } = store.imageFusionStore;
  const { isAuth } = store.uiStore;

  const [uploadSelectedObjects, setUploadSelectedObjects] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');


  // console.log(uploadSelectedObjects);
  const getUploadSelectedHandler = (objects) => {
    setUploadSelectedObjects(objects);
  }


  let imageResizerFileSelectContentsBody;

  if (!isAuth) {
    imageResizerFileSelectContentsBody = (
      <div>
        <div>
          <p>
            To select from uploaded files, login is required, or signup to create account.
          </p>
          <br/>

          <div className="resizerResizeLoginButtons">
            <a href={loginPageLink}>
              <button className="btnBase">
                {marks.signInMrak} {t('aboutPage.10', 'Login')}
              </button>
            </a>
            <span> {t('aboutPage.11', 'or')} </span>
            <a href={signupPageLink}>
              <button className="btnBase">
                {marks.userPlusMrak} {t('aboutPage.12', 'Signup')}
              </button>
            </a>
          </div>
        </div>
      </div>
    );

  } else {
    imageResizerFileSelectContentsBody = (
      <div>
        <section className="resizerFileSelectContentsSection">
          <div className="resizerFileSelectContentsSectionTitle">
            Selected Files
          </div>
          <ul className="resizerFileSelectedFiles">
            {uploadSelectedObjects.map(object => {
              if (!object.Key.endsWith('/')) {
                return (
                  <li key={object.Key}
                  >
                    {/* {getOriginalFileNameFromKey(object.Key)} */}
                    {decodeURI(getOriginalFileNameFromKey(object.Key))}
                  </li>
                );
              }
            })}
          </ul>
          <button className="btnBase"
            disabled={isLoading || uploadSelectedObjects.length === 0}
            onClick={() => {
              setResizerFilesFromUploadedHandler(uploadSelectedObjects);
            }}
          >
            Import into Image Resizer
          </button>
        </section>

        <section className="resizerFileSelectContentsSection">
          <div className="resizerFileSelectContentsSectionRow">
            <span className="resizerFileSelectContentsSectionTitle">
              Select image files
            </span>
          </div>
          <div className="resizerFileSelectContentsSectionRow">
            <FolderAndFile 
              onFileClick={() => {}}
              withImageLink={true}
              withAllLink={false}
              withCheckbox={true}
              getUploadSelectedHandler={getUploadSelectedHandler}
            />
          </div>
        </section>
      </div>
    );
  }



  return (
    <Fragment>
      <div className="resizerFileSelectContents">
        {imageResizerFileSelectContentsBody}
        {errorMessage && (
          <div>
            <strong>{errorMessage}</strong>
          </div>
        )}
      </div>
    </Fragment>
  );
}
